const ResourcesLandingSection = () => {
    return (
      <section
        className="landing-1"
        style={{ backgroundImage: "url(/img/landing-2.png)" }}
      >
        <div className="container-xl container--1">
          <h1>Resources</h1>
          <p>Uthsav has a lot of helpful resources and tips to help you make the most of your event--blogs, videos, expert advice and more. Dive right in, and feel free to drop us a note. One of our vast team of resources will be live to talk to you.</p>
         
        </div>
      </section>
    );
  };
  
  export default ResourcesLandingSection;
  